import type { RouteRecordRaw } from 'vue-router';

import { buildTariffSandboxRoutes } from '@/router/tariff-sandbox';

import { getTenantName } from '@/utility/tenant-config'; // tariff-sandbox (ITLV-1077): remove with the sandbox

export const routes = [
  {
    name: 'Login',
    path: '/login',
    component: () => import('@/views/LoginView.vue'),
  },
  {
    name: 'AccessDenied',
    path: '/access-denied',
    component: () => import('@/views/AccessDenied.vue'),
  },
  {
    name: 'NoSeatsAvailable',
    path: '/no-seats',
    component: () => import('@/views/NoSeats.vue'),
  },
  {
    path: '/users',
    children: [
      {
        name: 'UserManagement',
        path: '',
        component: () => import('@/views/UserManagement.vue'),
      },
      {
        name: 'UserDetails',
        path: ':id',
        component: () => import('@/views/UserDetails.vue'),
        props: true,
      },
    ],
  },
  {
    name: 'SkillManagement',
    path: '/skills',
    component: () => import('@/views/SkillManagement.vue'),
    props: true,
  },
  {
    path: '/teams',
    children: [
      {
        name: 'TeamManagement',
        path: '',
        component: () => import('@/views/TeamManagement.vue'),
      },
      {
        name: 'TeamDetails',
        path: ':id',
        component: () => import('@/views/TeamDetails.vue'),
        props: true,
      },
    ],
  },
  {
    name: 'Dashboard',
    path: '/dashboard',
    component: () => import('@/views/DashboardView.vue'),
  },
  {
    path: '/targets',
    children: [
      {
        name: 'TargetManagement',
        path: '',
        component: () => import('@/views/TargetManagement.vue'),
      },
      {
        name: 'TargetDetails',
        path: ':id',
        component: () => import('@/views/TargetDetails.vue'),
        props: true,
      },
    ],
  },
  {
    path: '/rules',
    children: [
      {
        name: 'RuleManagement',
        path: '',
        component: () => import('@/views/RuleManagement.vue'),
      },
      {
        name: 'RuleDetails',
        path: ':id',
        component: () => import('@/views/RuleDetails.vue'),
        props: true,
      },
    ],
  },
  {
    path: '/channels',
    children: [
      {
        name: 'ChannelManagement',
        path: '',
        component: () => import('@/views/ChannelManagement.vue'),
      },
      {
        name: 'ChannelDetails',
        path: ':id',
        component: () => import('@/views/ChannelDetails.vue'),
        props: true,
      },
    ],
  },
  {
    name: 'CatalogManagement',
    path: '/catalog',
    component: () => import('@/views/CatalogManagement.vue'),
  },
  {
    path: '/administration',
    children: [
      {
        name: 'UserRoleManagement',
        path: 'roles',
        component: () => import('@/views/UserRoleManagement.vue'),
      },
      {
        name: 'AnswerManagement',
        path: 'answers',
        component: () => import('@/views/AnswerManagement.vue'),
      },
      {
        name: 'TariffManagement',
        path: 'tariffs',
        component: () => import('@/views/TariffManagement.vue'),
      },
      {
        name: 'TariffDetails',
        path: 'tariffs/:id',
        component: () => import('@/views/TariffDetails.vue'),
        props: true,
      },
      {
        name: 'Billing',
        path: 'billing',
        component: () => import('@/views/BillingView.vue'),
      },
      {
        name: 'Settings',
        path: 'settings',
        component: () => import('@/views/SettingsView.vue'),
      },
      {
        name: 'AuditLogs',
        path: 'logs',
        component: () => import('@/views/AuditLogs.vue'),
      },
      {
        name: 'SSOConfig',
        path: 'sso-config',
        component: () => import('@/views/SSOConfig.vue'),
      },
    ],
  },
  {
    path: '/dev',
    children: [
      {
        path: 'interaction-opportunities',
        name: 'DevInteractionOpportunities',
        component: () => import('@/views/InteractionOpportunities.vue'),
      },
      {
        path: 'customers',
        name: 'DevCustomersOverview',
        component: () => import('@/views/CustomersOverview.vue'),
      },
      {
        path: 'recalc-trigger',
        name: 'DevRecalcTrigger',
        component: () => import('@/views/RecalcTrigger.vue'),
      },
      {
        path: 'feature-flags',
        name: 'DevFeatureFlags',
        component: () => import('@/views/FeatureFlags.vue'),
      },
      {
        path: 'valkey',
        name: 'DevValkey',
        component: () => import('@/views/ValkeyKeys.vue'),
      },
    ],
  },
  ...buildTariffSandboxRoutes(getTenantName()), // tariff-sandbox (ITLV-1077): remove with the sandbox
  {
    path: '/',
    redirect: '/login',
  },
] as const satisfies RouteRecordRaw[];

type PickRouteNames<T> = T extends readonly unknown[]
  ? PickRouteNames<T[number]>
  : T extends { name: infer N extends string }
    ? N | (T extends { children: infer C } ? PickRouteNames<C> : never)
    : T extends { children: infer C }
      ? PickRouteNames<C>
      : never;

export type RouteName = PickRouteNames<typeof routes>;
